import actions from 'store/actions'

import { default as contentfulTypes } from './types'

const fetchingActions = actions.createFetchingActions(contentfulTypes)

export default {
  ...fetchingActions,
}
